module.exports = __webpack_public_path__ + "static/contact-mobile-ee1d67f50d9ecb60adb44f247775a4cc.png";